/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * creates a collection of static breakpoints that are prepared to be used with
 * CSS-in-JS
 *
 * the breakpoints are automatically prepared to be used with utility hooks
 * from `packages/react-utils` and are optimized for accessibility concerns by
 * honoring user settings and zoom levels
 *
 * @see https://zellwk.com/blog/media-query-units/
 */
function makeBreakpoints(config) {
  let prevValue = undefined;
  const breakpoints = Object.entries(config).reverse().reduce((acc, [breakpoint, value]) => {
    const from = value;
    const to = prevValue !== undefined ? prevValue - 1 : undefined;
    acc[breakpoint] = makeBreakpoint(from, to);
    prevValue = value;
    return acc;
  }, {});
  return Object.assign(breakpoints, {
    range(from, to) {
      return makeBreakpoint(breakpoints[from].from, breakpoints[to].to);
    }
  });
}
function makeBreakpoint(from, to) {
  return {
    from,
    to,
    toQuery: () => makeBreakpointQuery(from, to),
    andUp: () => makeBreakpoint(from, undefined),
    andDown: () => makeBreakpoint(0, to)
  };
}
function makeBreakpointQuery(from, to) {
  return ["screen", stringifyBreakpoint(from, "from"), stringifyBreakpoint(to, "to")].filter(it => !!it).join(" and ");
}
function stringifyBreakpoint(valuePx, target) {
  if (valuePx === undefined) {
    return;
  }

  // NB: We convert breakpoints to em for optimal rendering across browsers and
  // configurations, see https://zellwk.com/blog/media-query-units/
  const valueEm = valuePx / 16;
  if (target === "from") {
    return valueEm > 0 ? `(min-width: ${valueEm}em)` : undefined;
  } else {
    return `(max-width: ${valueEm}em)`;
  }
}

/**
 * Helpers to convert union to array.
 *
 * e.g. "a" | "b" -> ["a", "b"]
 */
// credits goes to https://stackoverflow.com/a/50375286

/**
 * Helpers to add to numbers
 *
 * @example
 * Add<3, 2> -> 5
 * Add<'oops', 2> -> -1
 */

/**
 * Helper to get the index of a specific key in an array
 *
 * @example
 * IndexOf<'b', ['a', 'b']> -> 1
 * IndexOf<'c', ['a', 'b']> -> -1
 */

export { makeBreakpoint, makeBreakpoints };
//# sourceMappingURL=maker.breakpoints.js.map
